import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { NgToastService } from 'ng-angular-popup';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { Router } from '@angular/router';
import { environment } from '@/app/environments/environment';
import { WrapperComponent } from '@/app/components/projects/wrapper/wrapper.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { BriefSectionComponent } from '@/app/components/projects/project-development/tendering/project-expression-of-interest/brief-section/brief-section.component';
import { PqqReadOnlyFormComponent } from '@/app/components/projects/project-development/tendering/pqq/pqq-developer/pqq-read-only-form/pqq-read-only-form.component';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
@Component({
  standalone: true,
  imports: [
    MatChipsModule,
    MatButtonModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    BriefSectionComponent,
    PqqReadOnlyFormComponent,
    WrapperComponent,
  ],
  selector: 'app-individual-pqq-view-submit',
  templateUrl: './individual-pqq-view-submit.component.html',
  styleUrls: ['./individual-pqq-view-submit.component.css'],
})
export class IndividualPqqViewSubmitComponent implements OnInit {
  currentDialog = 'applicant-sections';
  projectIdNew: string;
  isEdit = false;
  submittedInitiation: any;
  projectId: any;
  isApplied = false;
  isAppliedPage = false;
  constructor(
    private toast: NgToastService,
    private sanitizer: DomSanitizer,
    private GetProjectIdService: GetProjectIdService,
    private projectsService: ProjectsService,
    private router: Router,
    private TenderingService: TenderingService
  ) {}
  // form: FormGroup;
  mapLink!: SafeResourceUrl;
  google_api_key = environment.apiKey;
  searchTerm = '';
  filteredOrganizations: any[] = [];
  resetRichTextEditor = false;
  eoiData: any;
  other = false;
  private subscription: Subscription = new Subscription();
  selectedWorkPackages: { id: number; name: string }[] = [];
  inputData: any;
  submittedResponse: any;

  ngOnInit(): void {
    this.preInitiationData();
    this.submittedInitiationData();
    this.isAppliedPage = this.TenderingService.getAppliedState();
    this.subscription = this.GetProjectIdService.projectId$.subscribe((id) => {
      this.projectIdNew = id;
      if (!this.projectIdNew) {
        this.projectIdNew = this.GetProjectIdService.getProjectId();
      }
      this.preInitiationData();
      this.submittedInitiationData();
      this.getSubmittedResponseData();
    });
    console.log(
      'The isAPplied state si:',
      this.TenderingService.getAppliedState()
    );
  }

  getSubmittedResponseData(): any {
    return this.projectsService.PQQSubmittedResponseData().subscribe({
      next: (response: any) => {
        this.submittedResponse = response?.data;
        const isValid =
          this.submittedResponse &&
          Object.values(this.submittedResponse).every(
            (value) => value !== null
          );

        // Set state based on the check
        this.isAppliedPage = isValid;
        console.log('Submitted Response Data is: ', response?.data);
      },
      error: (error) => {
        console.error('Error fetching response:', error);
      },
    });
  }

  submittedInitiationData(): any {
    return this.projectsService.getSubmittedInitiationDataPQQ().subscribe({
      next: (response: any) => {
        this.submittedInitiation = response?.data;
        if (response?.data) {
          this.inputData = {
            refrenceNumber: response?.data?.reference_number,
            client: response?.data?.client,
            issueDate: response?.data?.issue_date,
            submissionDeadline: response?.data?.submission_deadline,
          };
        }
      },
      error: (error) => {
        console.error('Error fetching projects:', error);
      },
    });
  }

  formatDate(dateString: string): string | null {
    if (!dateString) return null;
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // Add leading zero
    const day = ('0' + date.getDate()).slice(-2); // Add leading zero

    return `${year}-${month}-${day}`;
  }

  preInitiationData() {
    this.projectsService.getPreInitiationData().subscribe({
      next: (response: any) => {
        this.eoiData = response.data;
        if (this.eoiData) {
          // Convert latitude and longitude to numbers
          const latitude = parseFloat(this.eoiData.projectDetails.latitude);
          const longitude = parseFloat(this.eoiData.projectDetails.longitude);

          // Check if the conversion was successful
          if (!isNaN(latitude) && !isNaN(longitude)) {
            const url = `https://www.google.com/maps/embed/v1/place?key=${this.google_api_key}&q=${latitude},${longitude}&zoom=12`;
            this.mapLink = this.sanitizer?.bypassSecurityTrustResourceUrl(url);
          } else {
            this.mapLink = null;
          }
        }
      },
      error: (error: any) => {
        console.error('Failed to fetch EOI initiation data:', error);
      },
    });
  }

  fillResponseForms() {
    this.isApplied = true;
    this.isEdit = true;
  }

  handleDialog() {
    this.isApplied = false;
    this.getSubmittedResponseData();
  }

  getSanitizedHtml(description: string) {
    if (!description) {
      return '';
    }
    return this.sanitizer.bypassSecurityTrustHtml(description);
  }
  handleClose() {
    this.router.navigate(['/pqq-requests']);
  }

  submitResponse() {
    return this.projectsService.PQQSubmitResponse().subscribe({
      next: () => {
        this.toast.success('Response submitted', 'SUCCESS');
        localStorage.removeItem('pqq_response_id');
      },
      error: (error) => {
        console.error('Error fetching response:', error);
      },
    });
  }
}
